<template>
    <div class="container-fluid">
        <div class="d-flex mt-5 flex-column">
            <!-- LOGOUT MESSAGE (IF ANY) -->
            <div v-if="logoutMsg" class="d-flex mt-5 justify-content-center" :style="{ color: 'darkred' }">
                {{ $t(logoutMsg) }}
            </div>
            <!-- LOGIN FORM -->
            <div class="d-flex mt-5 justify-content-center">
                <form
                    class="col-sm-6 col-md-5 col-lg-4 col-xl-3"
                    role="form"
                    autocomplete="off"
                    v-on:submit.prevent="handleSubmit"
                >
                    <!-- E-MAIL -->
                    <div class="form-group">
                        <label for="email">{{ $t('email') }}</label>
                        <input
                            class="form-control"
                            type="email"
                            id="email"
                            v-model="email"
                            :class="{ 'is-invalid': submitClicked && !email }"
                        />
                        <div v-show="submitClicked && !email" class="invalid-feedback">
                            {{ $t('email') }} {{ $t('is_required') }}
                        </div>
                    </div>
                    <!-- PASSWORD -->
                    <div class="form-group">
                        <label for="password">{{ $t('password') }}</label>
                        <input
                            class="form-control"
                            type="password"
                            id="password"
                            autocomplete="off"
                            v-model="password"
                            :class="{ 'is-invalid': submitClicked && !password }"
                        />
                        <div v-show="submitClicked && !password" class="invalid-feedback">
                            {{ $t('password') }} {{ $t('is_required') }}
                        </div>
                    </div>
                    <div class="alert alert-danger" v-show="status.error" role="alert">
                        {{ $t(status.message) }}
                    </div>
                    <!-- BUTTONS: LOGIN, FORGOT PASSWORD -->
                    <div class="form-group mt-4">
                        <button
                            type="submit"
                            class="btn btn-success float-left"
                            :disabled="!email || !password || submitClicked"
                        >
                            {{ $t('login') }}
                        </button>
                        <router-link :to="{ name: 'reset-password' }" class="float-right">
                            {{ $t('forgot_password') }}
                        </router-link>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    name: 'login',
    computed: {
        ...mapState('account', ['status', 'user', 'logoutMsg'])
    },
    data() {
        return {
            email: null,
            password: null,
            submitClicked: false
        };
    },
    methods: {
        ...mapActions('account', ['login', 'logout']),
        // handle submit click (login)
        async handleSubmit() {
            this.submitClicked = true;
            await this.login({
                email: this.email,
                password: this.password
            });
            this.submitClicked = false;
        }
    }
};
</script>
